import { render, staticRenderFns } from "./ExtendedCard.vue?vue&type=template&id=e580c288&scoped=true&"
import script from "./ExtendedCard.vue?vue&type=script&lang=js&"
export * from "./ExtendedCard.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedCard.vue?vue&type=style&index=0&id=e580c288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e580c288",
  null
  
)

export default component.exports